import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { SvgBookmarkFill } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { CONTENT_CATEGORY, GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
interface NewsCardProps {
  id?: number;
  isLoading?: boolean;
  imageSrc?: string;
  title?: string;
  content?: string;
  link?: string;
  daysAgo?: string;
  isBookmarked?: boolean;
  bookmarkCount?: number;
  onClickBookmark?: () => void;
  children?: React.ReactNode;
}
export const NewsCard = t0 => {
  const $ = _c(36);
  const {
    id,
    link: t1,
    isLoading: t2,
    imageSrc,
    title,
    content,
    daysAgo,
    bookmarkCount,
    isBookmarked,
    onClickBookmark,
    children
  } = t0;
  const link = t1 === undefined ? "#" : t1;
  const isLoading = t2 === undefined ? false : t2;
  const shouldRenderBookmark = typeof bookmarkCount === "number" || typeof isBookmarked === "boolean" || typeof onClickBookmark === "function";
  let t3;
  if ($[0] !== id || $[1] !== isLoading || $[2] !== title) {
    t3 = e => {
      trackGtmEvent(GTM_EVENT_TYPE.SELECT_CONTENT, {
        content_name: title || "",
        content_category: CONTENT_CATEGORY.POLICY,
        content_id: id?.toString() || ""
      });
      if (isLoading) {
        e.preventDefault();
      }
    };
    $[0] = id;
    $[1] = isLoading;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isLoading || $[5] !== title) {
    t4 = isLoading ? <div><Skeleton className="mb-8 h-20 w-300" /><Skeleton className="h-20 w-150" /></div> : title ? <h2 className="line-clamp-2 break-all font-500 text-Gray-900 typo-body3">{title}</h2> : null;
    $[4] = isLoading;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== content) {
    t5 = content ? <p className="line-clamp-1 break-all font-400 text-Gray-700 typo-body4">{content}</p> : null;
    $[7] = content;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex min-w-0 flex-1 flex-col gap-4">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== imageSrc || $[13] !== isLoading) {
    t7 = isLoading ? <Skeleton className="size-74 shrink-0 rounded-small" /> : imageSrc ? <Image alt="thumbnail" className="aspect-square shrink-0 rounded-small border-1 border-Gray-300 object-cover" height={74} src={imageSrc} width={74} /> : null;
    $[12] = imageSrc;
    $[13] = isLoading;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex items-center gap-14">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== daysAgo || $[19] !== isLoading) {
    t9 = isLoading ? <Skeleton className="h-19 w-60" /> : daysAgo;
    $[18] = daysAgo;
    $[19] = isLoading;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== bookmarkCount || $[22] !== isBookmarked || $[23] !== isLoading || $[24] !== onClickBookmark || $[25] !== shouldRenderBookmark) {
    t10 = isLoading ? <Skeleton className="h-19 w-65" /> : shouldRenderBookmark ? <div className="flex items-center gap-2 font-400 text-Gray-600"><button type="button" className="group gap-5 flex-center typo-caption1" onClick={e_0 => {
        e_0.stopPropagation();
        e_0.preventDefault();
        onClickBookmark?.();
      }}><SvgBookmarkFill className={cn("size-16 text-Gray-400 transition-all duration-75 group-active:scale-75", {
          "text-B-500": isBookmarked
        })} /></button>{typeof bookmarkCount === "number" ? <p className="font-400 text-Gray-700 typo-caption1">{bookmarkCount}</p> : null}</div> : null;
    $[21] = bookmarkCount;
    $[22] = isBookmarked;
    $[23] = isLoading;
    $[24] = onClickBookmark;
    $[25] = shouldRenderBookmark;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <footer className="flex items-center justify-between font-400 text-Gray-600 typo-caption1">{t9}{t10}</footer>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== children || $[31] !== link || $[32] !== t11 || $[33] !== t3 || $[34] !== t8) {
    t12 = <CustomLink className="flex flex-col gap-16 border-b border-Gray-200 p-16" href={link} onClick={t3}>{t8}{children}{t11}</CustomLink>;
    $[30] = children;
    $[31] = link;
    $[32] = t11;
    $[33] = t3;
    $[34] = t8;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};